import React, {PropsWithChildren, useState} from "react";

interface PreloaderContextState {
    isFullPagePreloaderVisible: boolean;
    showFullPagePreloader: () => void;
    hideFullPagePreloader: () => void;
    isMiddlePagePreloaderVisible: boolean;
    showMiddlePagePreloader: () => void;
    hideMiddlePagePreloader: () => void;
}

export const PreloaderContext = React.createContext({} as PreloaderContextState);

export const PreloaderProvider: React.FunctionComponent<PropsWithChildren> = ({children}) => {
    const [isFullPagePreloaderVisible, setFullPagePreloaderVisible] = useState<boolean>(false);
    const [isMiddlePagePreloaderVisible, setMiddlePagePreloaderVisible] = useState<boolean>(false);

    const showFullPagePreloader = () => {
        setFullPagePreloaderVisible(true);
    }

    const hideFullPagePreloader = () => {
        setFullPagePreloaderVisible(false);
    }

    const showMiddlePagePreloader = () => {
        setMiddlePagePreloaderVisible(true);
    }

    const hideMiddlePagePreloader = () => {
        setMiddlePagePreloaderVisible(false);
    }

    return (
        <PreloaderContext.Provider value={{
            isFullPagePreloaderVisible,
            showFullPagePreloader,
            hideFullPagePreloader,
            isMiddlePagePreloaderVisible,
            showMiddlePagePreloader,
            hideMiddlePagePreloader
        }}>
            {children}
        </PreloaderContext.Provider>
    )
}